"use client";

import { createContext, useContext, type ReactNode } from "react";

interface TenantBrandingContextValue {
  initialLogoUrl: string | null;
}

const TenantBrandingContext = createContext<TenantBrandingContextValue>({
  initialLogoUrl: null,
});

export function TenantBrandingProvider({
  initialLogoUrl,
  children,
}: {
  initialLogoUrl?: string | null;
  children: ReactNode;
}) {
  return (
    <TenantBrandingContext.Provider value={{ initialLogoUrl: initialLogoUrl ?? null }}>
      {children}
    </TenantBrandingContext.Provider>
  );
}

export function useTenantBranding() {
  return useContext(TenantBrandingContext);
}
